"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var CanvaEditButton = function CanvaEditButton(_ref) {
  var disabledReason = _ref.disabledReason,
      isDisabled = _ref.isDisabled,
      isDownloading = _ref.isDownloading,
      loadingButton = _ref.loadingButton,
      openCanva = _ref.openCanva;
  return _react.default.createElement(_UITooltip.default, {
    title: disabledReason
  }, isDownloading ? loadingButton : _react.default.createElement(_UIButton.default, {
    disabled: isDisabled,
    onClick: openCanva
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "FileManagerCore.actions.editInCanva"
  }), _react.default.createElement(_Small.default, {
    className: "display-block m-all-0"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "FileManagerCore.canva.editButton"
  }))));
};

CanvaEditButton.propTypes = {
  disabledReason: _propTypes.default.node,
  isDisabled: _propTypes.default.bool.isRequired,
  isDownloading: _propTypes.default.bool.isRequired,
  loadingButton: _propTypes.default.node.isRequired,
  openCanva: _propTypes.default.func.isRequired
};
var _default = CanvaEditButton;
exports.default = _default;
module.exports = exports.default;